<template>
  <div v-if="state.instances.length">
    <b-pagination
      v-model="state.current"
      :total="state.total"
      :simple="false"
      :per-page="perPage"
      order="is-centered"

      aria-next-label="Siguientes resultados"
      aria-previous-label="Resultados anteriores"
      aria-page-label="Resultados"
      aria-current-label="Resultados actuales"
    >
      <b-pagination-button
        slot="previous"
        slot-scope="props"
        tag="router-link"
        :page="props.page"
        :to="pageLink(props.page.number)"
      >
        Anteriores
      </b-pagination-button>
      <b-pagination-button
        slot="default"
        slot-scope="props"
        tag="router-link"
        :page="props.page"
        :to="pageLink(props.page.number)"
      >
        {{ props.page.number }}
      </b-pagination-button>
      <b-pagination-button
        slot="next"
        slot-scope="props"
        tag="router-link"
        :page="props.page"
        :to="pageLink(props.page.number)"
      >
        Siguientes
      </b-pagination-button>
    </b-pagination>
  </div>
</template>

<script>
import store from "@/store";

export default {
  props: { page, perPage: 12, rangeBefore: 3, rangeAfter: 1 },
  methods: {
    pageLink(page) {
      const query = Object.assign({}, this.$route.query, { page });
      return { query };
    },
  },
  data() {
    return {
      state: store.state,
    };
  },
};
</script>